import axiosInstance from "./axiosInstance"


export const getLocations = async () => {
    try {
        const response = await axiosInstance.get('/location')
        return response.data
    } catch (error) {
        console.error('Failed to fetch locations', error)
        throw error
    }
}

export const createLocation = async (data) => {
    try {
        const response = await axiosInstance.post('/location', data)
        return response.data
    } catch (error) {
        console.error('Failed to create location', error)
        throw error
    }
}

export const deleteLocation = async (cityName) => {
    try {
        const response = await axiosInstance.delete(`/location`, {data: {cityName: cityName}})
        return response.data
    } catch (error) {
        console.error('Failed to delete location', error)
        throw error
    }
}

export const updateLocation = async (id, data) => {
    try {
        const response = await axiosInstance.put(`/location/${id}`, data)
        return response.data
    } catch (error) {
        console.error('Failed to update location', error)
        throw error
    }
}